<!-- お知らせ詳細画面 -->
<template>
  <div>
    <CrpgTemplatesNewsDetail />
  </div>
</template>

<script>
import CrpgTemplatesNewsDetail from "@/components/templates/NewsDetail.vue";
export default {
  name: "CrpgNewsDetail",

  components: {
    CrpgTemplatesNewsDetail,
  },
};
</script>
